/**
 * Lightweight route manifest used by the client router.
 *
 * Keep large page copy out of this module. AppRoutes is part of the initial
 * client bundle; importing the full landing-page, guide, name-list, and blog
 * datasets there made every visitor parse content for all 47 routes before
 * they could use the wheel. The lazy route components load the matching data
 * only when one of those routes is opened.
 */
export const LANDING_PATHS = [
  '/image-picker-wheel',
  '/weighted-wheel-spinner',
  '/random-team-generator',
  '/number-wheel',
  '/spin-the-bottle',
  '/wheel-of-fortune-maker',
  '/trivia-wheel',
  '/decision-wheel',
  '/prize-wheel',
  '/random-letter-wheel',
  '/anime-character-picker-wheel',
  '/fortnite-drop-spot-generator-wheel',
  '/valorant-agent-picker-wheel',
  '/roblox-game-selector-wheel',
] as const;

export const TEACHER_GUIDE_SLUGS = [
  'cold-calling-without-the-anxiety',
  'spinner-wheel-maths-activities',
  'random-grouping-that-works',
  'set-up-your-class-once',
] as const;

export const NAME_LIST_SLUGS = [
  'boho-baby-girl-names',
  'dog-names',
  'fantasy-character-names',
  'cool-usernames',
] as const;

export const BLOG_POST_SLUGS = [
  'classroom-icebreaker-spinner',
  'fair-prize-draw-events',
  'random-team-generator-pe',
  'cold-calling-students-fairly',
  'how-to-run-a-fair-online-giveaway',
  'random-team-generator-for-teachers',
  'gaming-wheel-challenge-ideas',
  'random-fortnite-drop-challenge',
] as const;

export const CONTENT_ROUTE_PATHS = [
  ...LANDING_PATHS,
  ...TEACHER_GUIDE_SLUGS.map(slug => `/classroom/resources/${slug}`),
  ...NAME_LIST_SLUGS.map(slug => `/names/${slug}`),
  ...BLOG_POST_SLUGS.map(slug => `/blog/${slug}`),
] as const;
